import React, { Fragment } from 'react';
import { useNavigate } from "@remix-run/react";
import { useTvGuideDate } from '../../components/DateSelection/use-tv-guide-date';
import { mobileHeaderHeight } from '../../components/Header/Header.globals';
import { PlayContainer, defaultContainerPadding } from '../../components/PlayContainer/PlayContainer';
import { TvGuide } from '../../components/TvGuide/TvGuide';
import { TvGuideDateSelection } from '../../components/TvGuideDateSelection/TvGuideDateSelection';
import { usePath, useVideoConfig } from '../../config/VideoAppContext';
import { isoDate } from '../../utils/date-formatter';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TvGuidePage = ({
  initialData: {
    tvGuide
  }
}) => {
  const {
    tvGuidePath
  } = usePath();
  const {
    businessUnit,
    tvGuide: {
      tvGuideChannelCount,
      tvGuideProviders = [businessUnit]
    } = {}
  } = useVideoConfig();
  const navigate = useNavigate();
  const {
    date,
    setDate
  } = useTvGuideDate();
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(TvGuideDateSelection, {
      date: date,
      onDateChange: value => navigate(tvGuidePath(isoDate(value))),
      onInstantChange: setDate,
      analyticsPageId: 'tvGuide'
    }), /*#__PURE__*/_jsx(PlayContainer, {
      sidePadding: {
        ...defaultContainerPadding,
        default: 0
      },
      children: /*#__PURE__*/_jsx(TvGuide, {
        date: isoDate(date),
        initialData: tvGuide,
        providers: tvGuideProviders,
        channelCount: tvGuideChannelCount,
        analyticsPageId: "tvGuide",
        stickyTopPosition: {
          default: mobileHeaderHeight,
          mediaQuery: []
        }
      })
    })]
  });
};